
export class FormatException extends Error {
  constructor(
    public readonly description: string,
  ) {
    super(description);
  }

  toString(): string {
    return `FormatException: ${this.description}`;
  }
}
